import Enums from '@/common/enums/Enums';

export const AddOrRemoveBasePlanActionTypes = new Enums({
  ADD: 'add',
  REMOVE: 'remove',
  // FREE TRIAL - if pro or base plan was free trial now, need to auto add a paid base plan for addon plan to upgrade
  ADD_PAID_BASE_PLAN_FOR_FREE_TRIAL_BASE_PLAN: 'addPaidBasePlanForFreeTrialBasePlan',
  REMOVE_PAID_BASE_PLAN_FOR_FREE_TRIAL_BASE_PLAN: 'removePaidBasePlanForFreeTrialBasePlan',
  NO_ACTION: '',
});
